module.exports = [
  require('./marut'),
  require('./maurezhi'),
  require('./meazel'),
  require('./merregon'),
  require('./moloch'),
  require('./molydeus'),
]
